import React, { createContext, useContext, useState, ReactNode } from "react";

interface UserSettingsContextType {
  isOpen: boolean;
  openSettings: () => void;
  closeSettings: () => void;
}

const UserSettingsContext = createContext<UserSettingsContextType>({
  isOpen: false,
  openSettings: () => {},
  closeSettings: () => {},
});

interface UserSettingsProviderProps {
  children: ReactNode;
}

export const UserSettingsProvider = ({
  children,
}: UserSettingsProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const openSettings = () => setIsOpen(true);
  const closeSettings = () => setIsOpen(false);

  return (
    <UserSettingsContext.Provider
      value={{ isOpen, openSettings, closeSettings }}
    >
      {children}
    </UserSettingsContext.Provider>
  );
};

export const useUserSettings = () => useContext(UserSettingsContext);
